(() => {
  const body = document.body;
  if (!body?.classList.contains('template-collection')) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const cards = [...document.querySelectorAll('.product-grid__item')];
  const heroMedia = document.querySelector('#MainContent > .hero-wrapper .hero__media');
  const facets = document.querySelector('.facets--horizontal');

  cards.forEach((card, index) => {
    card.style.setProperty('--zuofun-delay', `${Math.min(index % 4, 3) * 70}ms`);
  });

  if (!reduceMotion && 'IntersectionObserver' in window) {
    body.classList.add('zuofun-collection-ready');
    const revealObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-zuofun-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    cards.forEach((card) => revealObserver.observe(card));
  } else {
    cards.forEach((card) => card.classList.add('is-zuofun-visible'));
  }

  if (finePointer && !reduceMotion) {
    cards.forEach((item) => {
      const card = item.querySelector('product-card');
      if (!card) return;
      item.addEventListener('pointermove', (event) => {
        const rect = item.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        card.style.setProperty('--zuofun-tilt-x', `${x * 2.2}deg`);
        card.style.setProperty('--zuofun-tilt-y', `${y * -1.6}deg`);
      }, { passive: true });
      item.addEventListener('pointerleave', () => {
        card.style.setProperty('--zuofun-tilt-x', '0deg');
        card.style.setProperty('--zuofun-tilt-y', '0deg');
      }, { passive: true });
    });
  }

  let ticking = false;
  const updateScrollEffects = () => {
    const y = window.scrollY || 0;
    if (facets) facets.classList.toggle('is-zuofun-floating', y > facets.offsetTop + 24);
    if (heroMedia && !reduceMotion) {
      const hero = heroMedia.closest('.hero');
      const rect = hero?.getBoundingClientRect();
      if (rect && rect.bottom > 0) {
        heroMedia.style.transform = `translate3d(0, ${Math.min(y * 0.065, 34)}px, 0) scale(1.035)`;
      }
    }
    ticking = false;
  };

  window.addEventListener('scroll', () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(updateScrollEffects);
  }, { passive: true });
  updateScrollEffects();
})();
